import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigConstants,
    ConfigInstanceToken,
    ConfigInterface,
    ConfirmationServiceReportModel,
} from '@evorait/pace-core';

@Component({
    selector: 'pace-confirmation-service-report',
    templateUrl: './confirmation-service-report.component.html',
    styleUrls: ['./confirmation-service-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ConfirmationServiceReportComponent {
    @Input()
    public model: ConfirmationServiceReportModel;

    @Input()
    public parentForm: FormArray;

    public enableDataMaintenanceEnhancement: boolean;
    public constructor(
        @Inject(ConfigInstanceToken) private readonly configService: ConfigInterface,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.enableDataMaintenanceEnhancement = this.configService.getShowDataMaintenanceEnhancement();
    }

    public setCrmLongTextNOSRSetValue(): void {
        if (this.model.reportVisibilityToCustomer?.getSelectedValue() === ConfigConstants.optionValueNo) {
            this.model.crmLongTextNOSRSet.value = ConfigConstants.sapTrue;
        } else {
            this.model.crmLongTextNOSRSet.value = '';
        }
    }
}
